import { render, staticRenderFns } from "./footerComponent.vue?vue&type=template&id=19d1309a&scoped=true"
import script from "./footerComponent.vue?vue&type=script&lang=js"
export * from "./footerComponent.vue?vue&type=script&lang=js"
import style0 from "./footerComponent.vue?vue&type=style&index=0&id=19d1309a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d1309a",
  null
  
)

export default component.exports